export interface VideoInfo {
  id: string;
  filename: string;
  duration: number;
  fps: number;
  resolution: number[];
  cuts: number[];
  filmstripUrl: string;
  videoUrl: string;
}

export type EffectCategory = 'clip' | 'transition' | 'timed';

export interface EffectDefinition {
  id: string;
  name: string;
  code: string;
  category: EffectCategory;
  color: string;
  variants?: string[];
  hasDirection?: boolean;
  directions?: string[];
  hasDuration?: boolean;
  defaultDuration?: number;
  hasColor?: boolean;
  colorOptions?: string[];
}

export interface EffectMarker {
  id: string;
  effectId: string;
  effectCode: string;
  category: EffectCategory;
  time: number;
  params: Record<string, string | number>;
}

export const EFFECT_DEFINITIONS: EffectDefinition[] = [
  // Clip effects
  { id: 'SM', name: 'Stop Motion', code: 'SM', category: 'clip', color: '#4caf50' },
  { id: 'F', name: 'Flicker', code: 'F', category: 'clip', color: '#757575' },
  { id: 'O', name: 'Overlay', code: 'O', category: 'clip', color: '#e91e90', variants: ['1', '2', '3'] },
  { id: 'S_IO', name: 'Scale In/Out', code: 'SI', category: 'clip', color: '#29b6f6', directions: ['SI', 'SO'] },
  { id: 'C', name: 'Coloring', code: 'C', category: 'clip', color: '#ab47bc', hasColor: true, colorOptions: ['DEF', 'GREEN', 'BLUE'] },
  // Transition effects
  { id: 'B', name: 'Burn', code: 'B', category: 'transition', color: '#ff9800', variants: ['1', '2'] },
  { id: 'Z_IO', name: 'Zoom In/Out', code: 'ZI', category: 'transition', color: '#2196f3', directions: ['ZI', 'ZO'], hasDuration: true, defaultDuration: 0.33 },
  { id: 'F_IO', name: 'Fade In/Out', code: 'FI', category: 'transition', color: '#9c27b0', directions: ['FI', 'FO'], hasDuration: true, defaultDuration: 0.17 },
  { id: 'MI_O', name: 'Moving In/Out', code: 'MIU', category: 'transition', color: '#fdd835', directions: ['MIU', 'MID', 'MOU', 'MOD'], hasDuration: true, defaultDuration: 0.17 },
  { id: 'M', name: 'Moving', code: 'MU', category: 'transition', color: '#ffb300', directions: ['MU', 'MD', 'ML', 'MR'] },
  { id: 'RZ', name: 'Rotate+Zoom', code: 'RZ', category: 'transition', color: '#f44336' },
  // Timed effects
  { id: 'CA', name: 'Chromatic Aberration', code: 'CA', category: 'timed', color: '#d4a574', hasDuration: true, defaultDuration: 0.23 },
  { id: 'SH', name: 'Shaking', code: 'SH', category: 'timed', color: '#ef5350', hasDuration: true, defaultDuration: 0.46 },
];
